import * as React from 'react'

import { SCREENS } from './workflow'

const init = Object.keys(SCREENS) as AdminPlanStep[]

const useWorkflow = (form: AdminPlanForm, id?: string) => {
  const [workflow, setWorkflow] = React.useState(init)

  React.useEffect(() => {
    const next = init

    // add rules on workflow
    // every rule defined workflow cut

    // *************************************************
    //                  content rules
    // *************************************************

    // keep only map screen for update
    const UpdateRule = id ? ['space'] : []

    //combined every rules
    const wf = next.filter((w) => !UpdateRule.includes(w))

    setWorkflow(wf)
  }, [form, id])

  return [workflow] as const
}

export default useWorkflow
